/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function DataTableData() {
  const AppService = useAppServices();
  const [List, setList] = useState([]);
  const [loader, setloader] = useState(true);
  const navigate = useNavigate();

  const getCategories = async () => {
    const { response } = await AppService.apikey_queries.get();
    if (response) {
      setList(response.data);
    } else {
      setList([]);
    }
    setloader(false);
  };
  const onLoad = () => {
    getCategories();
  };

const downloadCSV = async (record) => {

  const { response } = await AppService.apikey_queries.getApikey({
    query: `query_id=${record._id}`,
  });

  const apiKeys = response.data;

  const headers = ["apiKey", "used"];
  const rows = apiKeys.map(obj =>
    headers.map(key => obj[key] ?? "").join(",") 
  );

  const csvContent = [headers.join(","), ...rows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.setAttribute("href", url);
  link.setAttribute("download", `${record.name || "apikeys"}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setloader(false);
};

  useEffect(onLoad, []);
  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: "Name", accessor: "name" },
        { Header: "Count", accessor: "count" },
        { Header: "Action", accessor: "action" },
      ],

      rows: List.map((data) => ({
        name: data.name,
        count: data.count,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="primary"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./view/${data._id}`)}>
                View
            </MDButton>

            <MDButton
              variant="contained"
              color="secondary"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => downloadCSV(data)}>
                Download Csv
            </MDButton>
          </MDBox>
        ),
      })),
    },
  };
}
